{
  "alert.informative": "Informatyvus",
  "alert.negative": "Neigiamas",
  "alert.notice": "Pranešimas",
  "alert.positive": "Teigiamas",
  "attachmentlist.nextAttachments": "Parodyti kitus priedus",
  "attachmentlist.previousAttachments": "Parodyti ankstesnius priedus",
  "chat.newMessage": "Naujas pranešimas",
  "chat.scrollToBottom": "Pereiti į apačią",
  "messagefeedback.thumbDown": "Blogas atsakas",
  "messagefeedback.thumbUp": "Geras atsakas",
  "promptfield.aiDisclaimer": "Atsakymai generuojami naudojant dirbtinį intelektą, todėl gali būti netikslūs. Prieš naudodami patikrinkite.",
  "promptfield.aiUserGuidlines": "Dirbtinio intelekto vartotojo gairės",
  "promptfield.attachments": "Priedai",
  "promptfield.insertButton": "Pridėti",
  "promptfield.label": "Užklausa",
  "promptfield.placeholder": "Pasiruošę pradėti? Užduokite klausimą, pasidalykite idėja arba pridėkite užduotį.",
  "promptfield.placeholder.small": "Klausti bet ko",
  "promptfield.stopButton": "Sustoti",
  "promptfield.submitButton": "Siųsti",
  "promptfield.uploading": "Įkėlimas",
  "responsestatus.loading": "Įkeliama",
  "responsestatus.processing": "Apdorojama...",
  "voicebutton.startListening": "Pradėti įrašymą",
  "voicebutton.stopListening": "Baigti įrašymą"
}
